<template>
<layout-content v-if="isShow">
  <template #headerTitle>
    <el-button
      icon="el-icon-back"
      size="small"
      style="float:left;"
      @click="onBackBtnClick"
    >返回上一级</el-button>

    <h1 class="layout-content-header-text" style="margin-left:.5em;">{{site.name}} / {{auditSiteDevice.name}} / 数据 {{numberToCN[stage]}} 审</h1>
  </template>

  <template #toolbar>
    <section class="toolbar-btn">
      <el-button
        type="success"
        icon="el-icon-monitor"
        size="small"
        @click="onFullScreenBtnClick"
      >{{showSideNav ? '全屏' : '恢复'}}显示</el-button>

      <el-button
        v-if="defectData.length > 0 && stage <= 1 && hasAuditBtn"
        type="warning"
        icon="el-icon-warning-outline"
        size="small"
        @click="openNoDataEditor"
      >
        数据缺失
      </el-button>

      <el-button
        v-if="hasAuditBtn"
        type="orange"
        icon="el-icon-edit-outline"
        size="small"
        @click="onAuditSubmitBtnClick"
      >
        <!-- 提交{{stage >= maxAuditStage ? '终' : numberToCN[stage + 1]}}审 -->
        {{stage >= maxAuditStage ? '终审确认' : `提交${numberToCN[stage + 1]}审`}}
      </el-button>

      <el-button
        v-if="hasAuditBtn && stage > 1"
        type="warning"
        icon="el-icon-close"
        size="small"
        @click="onBackReAuditBtnClick"
      >退回重审</el-button>

      <el-button
        v-if="!hasAuditBtn && isAdmin && stage >= maxAuditStage && (auditSiteDevice || {}).auditStage >= (1 << maxAuditStage)"
        type="warning"
        icon="el-icon-close"
        size="small"
        @click="onBackAuditedBtnClick"
      >退回重审</el-button>
    </section>
  </template>

  <template #body>
    <section class="audit-wrapper">
      <section class="audit-toolbar">
        <el-date-picker
          v-model="conditions.auditTime"
          type="date"
          format="yyyy年MM月dd日"
          value-format="yyyy/MM/dd"
          :clearable="false"
          :editable="false"
          size="small"
          style="width:170px;"
          @change="onAuditTimeChanged"
        />

        <el-select
          v-model="conditions.factorId"
          size="small"
          @change="onFactorIdChanged"
        >
          <el-option
            v-for="siteDeviceFactor in formatSiteDeviceFactors"
            :key="siteDeviceFactor.id"
            :value="siteDeviceFactor.id"
            :label="siteDeviceFactor.name"
          />
        </el-select>

        <el-input
          v-model="chartOpts.legendMinVal"
          type="number"
          size="small"
          style="width:180px;margin-left:.5em;"
          @change="onDataParamChanged"
        >
          <template slot="prepend">图例最小值</template>
        </el-input>
        <el-input
          v-model="chartOpts.legendMaxVal"
          type="number"
          size="small"
          style="width:180px;margin-left:.5em;"
          @change="onDataParamChanged"
        >
          <template slot="prepend">图例最大值</template>
        </el-input>
        <el-input
          v-model="chartOpts.minHeight"
          type="number"
          size="small"
          style="width:180px;margin-left:.5em;"
          @change="onDataParamChanged"
        >
          <template slot="prepend">高度最小值</template>
        </el-input>
        <el-input
          v-model="chartOpts.maxHeight"
          type="number"
          size="small"
          style="width:180px;margin-left:.5em;"
          @change="onDataParamChanged"
        >
          <template slot="prepend">高度最大值</template>
        </el-input>
      </section>

      <section class="audit-content">
        <section class="audit-content-inner">
          <lidar-chart-wrapper
            @lidar-chart-ready="onLidarChartReady"
            @lidar-chart-destroy="onLidarChartDestroy"
          />

          <section class="audit-table-wrapper">
            <el-table
              ref="table"
              :data="auditList"
              border
              stripe
              highlight-current-row
              header-row-class-name="custom-table-header"
              height="100%"
              class="custom-table no-inner-border"
              style="width: 100%"
              @row-click="onTableRowClick"
            >
              <el-table-column type="selection" width="38" />
              <el-table-column label="时间" prop="dataTime" />
            </el-table>
          </section>
        </section>
      </section>
    </section>
  </template>

  <template #editor>
    <el-dialog
      :title="`${auditSiteDevice.name}-数据缺失`"
      :visible.sync="centerDialogVisible"
      width="60%"
      :before-close="saveNoData"
      :show-close="false"
    >
      <div slot="title">
        <el-button
          v-if="noData.length === 0"
          icon="el-icon-back"
          size="small"
          style="float: right;"
          @click="onBackBtnClick"
        >返回上一级</el-button>

        <span class="layout-content-header-text" style="margin-left: 5px;font-weight: bold; font-size: 19px;">{{site.name}} / {{auditSiteDevice.name}}</span>
      </div>
      <div style="width: 100%; height: 500px;display: flex;">
        <el-table
          :data="tableData"
          border
          stripe
          height="100%"
          style="width: 59%"
          highlight-current-row
          header-row-class-name="custom-table-header"
          class="custom-table no-inner-border"
        >
          <el-table-column prop="dataTime" label="时间" />
          <el-table-column prop="cause" label="缺失原因">
            <template slot-scope="{row}">
              <div style="display: flex;align-items: center;justify-content: left;">
                <el-select v-model="row.cause" size="small" style="width: 200px;" @change="ratioChange">
                  <el-option
                    v-for="item in causeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <div
                  :class="row.cause === '' ? 'el-icon-circle-close' : 'el-icon-circle-check'"
                  :style="`color: ${row.cause === '' ? '#F85778' : '#1FC96E'};margin-left: 5px;`"
                ></div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-table
          :data="ratioData"
          border
          stripe
          height="100%"
          style="width: 40%;margin-left: 5px;"
          highlight-current-row
          header-row-class-name="custom-table-header"
          class="custom-table no-inner-border"
        >
          <el-table-column prop="factorName" label="因子名称" />
          <el-table-column prop="gatherRate" label="捕集率">
            <template slot-scope="{row}">
              {{(row.gatherRate * 100).toFixed(2)+ '%'}}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="orange" @click="saveNoData" style="margin-right: 5px;">提 交</el-button>
        <a class="cancel-btn btn" v-if="noData.length !== 0" @click="centerDialogVisible = false">关闭</a>
      </span>
    </el-dialog>
  </template>
</layout-content>
</template>

<script>
import BaseAuditDevice from './BaseAuditDevice'
import LidarChartWrapper from '../../../components/Data/ChartWrapper/LidarChartWrapper'
import {LIDAR_DATA_LIST_CHANGED, LIDAR_DATA_SELECT} from '../../../components/Data/ChartWrapper/EventKeys'
import {mapGetters} from 'vuex'

export default {
  name: 'AuditRadarDevice',
  extends: BaseAuditDevice,
  components: {LidarChartWrapper},
  data () {
    return {
      conditions: {
        factorId: null
      },
      chartOpts: {
        legendMinVal: 0,
        legendMaxVal: 1.5,
        minHeight: 200,
        maxHeight: 3495
      },
      auditList: [],
      defectData: [],
      tableData: [],
      selectNoData: [],
      noData: [],
      ratioData: [],
      centerDialogVisible: false
    }
  },
  computed: {
    ...mapGetters({
      showSideNav: 'Profile/showSideNav'
    }),
    siteDeviceCategory: () => process.env.LIDAR_DEVICE_CATEGORY,
    formatSiteDeviceFactors () {
      let {factorMap, siteDeviceFactors} = this
      return siteDeviceFactors.map(siteDeviceFactor => {
        let {factorId} = siteDeviceFactor
        let factor = factorMap[factorId]

        return {
          id: siteDeviceFactor.factorId,
          name: factor.name,
          decimalNum: factor.decimalNum,
          unit: factor.stdUnit,
          limitLow: siteDeviceFactor.limitLow,
          limitHigh: siteDeviceFactor.limitHigh
        }
      })
    },
    siteDeviceFactorMap () {
      return this.formatSiteDeviceFactors.reduce((map, siteDeviceFactor) => {
        map[siteDeviceFactor.id] = siteDeviceFactor
        return map
      }, {})
    },
    currentFactor () {
      return this.siteDeviceFactorMap[this.conditions.factorId]
    },
    causeOptions () {
      return [{
        label: '断电',
        value: 1
      }, {
        label: '例行运维',
        value: 2
      }, {
        label: '不可抗力',
        value: 4
      }, {
        label: '仪器故障/软件死机',
        value: 8
      }, {
        label: '正常缺失',
        value: 16
      }]
    }
  },
  methods: {
    onLidarChartReady (lidarEB) {
      this.lidarEB = lidarEB
    },
    onLidarChartDestroy () {
      this.lidarEB = null
    },
    onGetSiteDeviceFactor (siteDeviceFactors) {
      if (siteDeviceFactors.length > 0) {
        let {formatSiteDeviceFactors} = this
        let firstSiteDeviceFactor = formatSiteDeviceFactors[0]
        this.conditions.factorId = firstSiteDeviceFactor.id
        this.setChartOpts(firstSiteDeviceFactor)
      }
    },
    setChartOpts (siteDeviceFactor) {
      let {chartOpts} = this
      chartOpts.legendMinVal = siteDeviceFactor.limitLow
      chartOpts.legendMaxVal = siteDeviceFactor.limitHigh
    },
    formatDataList (dataList) {
      this.dataList = Object.freeze(dataList.map(data => ({
        id: data.id,
        dataTime: data.dataTime,
        value: data.dasValue.split('|').map(value => value === '' ? null : Number(value)),
        dasFlag: data.dasFlag
      })))

      this.auditList = dataList.map(data => ({
        dataTime: data.dataTime
      }))

      this.renderChart()
    },
    renderChart () {
      let {dataList} = this

      if (!Array.isArray(dataList)) {
        return
      }

      let {auditSiteDevice, currentFactor, conditions: {auditTime}, chartOpts} = this
      let beginTime = new Date(auditTime)
      beginTime.setHours(process.env.AUDIT_BEGIN_HOUR, 0, 0)
      let endTime = new Date(beginTime)
      endTime.setHours(endTime.getHours() + 24)

      for (let key in chartOpts) {
        chartOpts[key] = Number(chartOpts[key])
      }

      this.lidarEB.$emit(LIDAR_DATA_LIST_CHANGED, {
        id: currentFactor.id,
        name: currentFactor.name,
        heights: auditSiteDevice.detectionHeights,
        values: dataList,
        dataFrequency: auditSiteDevice.dataFrequency,
        beginTime,
        endTime,
        colors: [[0, 0, 255], [0, 255, 255], [0, 255, 0], [255, 255, 0], [255, 0, 0]],
        ...chartOpts
      })
    },
    onFactorIdChanged (factorId) {
      this.setChartOpts(this.currentFactor)
      this.getAuditDataBySiteDevice()
    },
    onAuditSubmitBtnClick () {
      this.submitAudit()
    },
    onDataParamChanged () {
      this.renderChart()
    },
    onTableRowClick (row) {
      this.lidarEB.$emit(LIDAR_DATA_SELECT, row.dataTime)
    },
    showElDiolog () {
      let {conditions: {auditTime}} = this
      let deviceId = this.auditSiteDevice.id

      this.$api.NoData.getNoData(auditTime, deviceId).then(data => {
        // 统计出某时段 所有因子都没有数据的时段数据（即补全数据的时段
        let flag = false
        let defectData = this.auditSiteDevice.dataHarvestRates ? this.auditSiteDevice.dataHarvestRates.filter(el => el.harvestRate === 0) : []
        this.defectData = defectData
        if (defectData.length > 0) {
          flag = true
        }

        // 一审 无已完成处理的缺失数据 所有因子都缺失
        if (this.stage <= 1 && data.length === 0 && flag) {
          this.getRatio(defectData)
          this.centerDialogVisible = true
        }
      }).catch(console.error)
    },
    openNoDataEditor () {
      let {conditions: {auditTime}} = this
      let deviceId = this.auditSiteDevice.id
      console.log(auditTime, deviceId)

      this.$api.NoData.getNoData(auditTime, deviceId).then(data => {
        this.noData = data
        this.getRatio(this.defectData)
        this.centerDialogVisible = true
      }).catch(console.error)
    },
    ratioChange () {
      let reduceDenominator = 0
      this.tableData.forEach(el => {
        if (el.cause <= 4 && el.cause !== '') {
          reduceDenominator += 1
        }
      })
      this.ratioData = this.ratioData.map(el => {
        let temp = el
        if (this.noData.length === 0) {
          temp.reduceDenominator = reduceDenominator
          temp.gatherRate = isNaN(temp.gatherNumerator / (temp.gatherDenominator - reduceDenominator)) ? 0 : temp.gatherNumerator / (temp.gatherDenominator - reduceDenominator)
        } else {
          temp.reduceDenominator = reduceDenominator
          temp.gatherDenominator = 24
          temp.gatherRate = isNaN(temp.gatherNumerator / (temp.gatherDenominator - reduceDenominator)) ? 0 : temp.gatherNumerator / (temp.gatherDenominator - reduceDenominator)
        }

        return temp
      })
    },
    getRatio (defectData) {
      let {auditSiteDevice, conditions} = this
      this.$api.Audit.getRatio(auditSiteDevice.id, conditions.auditTime).then(data => {
        this.noDataRatioFormat(data, defectData)
      }).catch(console.error)
    },
    noDataRatioFormat (data, defectData) {
      let siteId = this.site.id
      let deviceId = this.auditSiteDevice.id
      // console.log(this.dataList, siteId, deviceId, data)

      let tableData = defectData.reduce((map, el) => {
        if (!map[el.dataTime]) {
          map[el.dataTime] = {
            dataTime: el.dataTime,
            siteId: siteId,
            siteDeviceId: deviceId,
            cause: ''
          }
        }

        return map
      }, {})

      let {noData, factorMap} = this
      if (noData.length > 0) {
        noData.forEach(el => {
          let dataTime = new Date(el.dataTime + ':00:00').format('YYYY/MM/DD HH:00:00')
          tableData[dataTime].cause = el.cause
        })
      }

      let ratioData = []
      for (let key in data) {
        ratioData.push({
          factorName: factorMap[key] ? factorMap[key].name : '--',
          factorId: factorMap[key] ? factorMap[key].id : null,
          ...data[key],
          reduceDenominator: 0
        })
      }

      this.ratioData = ratioData
      this.tableData = Object.values(tableData)
    },
    saveNoData () {
      let {tableData, conditions: {auditTime}} = this
      let deviceId = this.auditSiteDevice.id
      let flag = true
      tableData.forEach(el => {
        if (el.cause === '') {
          flag = false
        }
      })

      if (!flag && this.noData.length === 0) {
        this.$notify.error({
          title: '错误',
          position: 'bottom-right',
          message: '请完成所有缺失数据原因的选择'
        })
        return false
      }

      let noDataRecords = tableData.map(el => {
        return {
          dataTime: el.dataTime,
          cause: el.cause,
          siteDeviceId: el.siteDeviceId,
          siteId: el.siteId
        }
      })

      if (new Date(auditTime).getTime() > new Date().getTime() - 86400000) {
        this.$notify.error({
          title: '错误',
          position: 'bottom-right',
          message: '超出审核有效时间'
        })
        return false
      }

      this.$api.NoData.saveNoData({siteDeviceId: deviceId, auditTime: auditTime, noDataRecords: noDataRecords}).then(res => {
        this.centerDialogVisible = false
      }).catch(console.error)
    },
    onFullScreenBtnClick () {
      this.$store.commit('Profile/showSideNav', !this.showSideNav)
      setTimeout(() => {
        let event = document.createEvent('HTMLEvents')
        event.initEvent('resize', true, true)
        window.dispatchEvent(event)
      }, 0)
    }
  },
  watch: {
    auditSiteDevice (val) {
      if (val) {
        this.showElDiolog()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-input {
  /deep/ .el-input-group__prepend {
    padding: {
      right: 7px;
      left: 7px;
    }
  }
}

.audit-wrapper {
  $TOOLBAR-HEIGHT: 32px;

  position: relative;
  width: 100%;
  height: 100%;
  padding-top: $TOOLBAR-HEIGHT;
  padding-left: 0.8em;

  > .audit-toolbar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: $TOOLBAR-HEIGHT;
    text-align: center;
  }

  > .audit-content {
    width: 100%;
    height: 100%;
    padding-top: 20px;

    > .audit-content-inner {
      position: relative;
      width: 100%;
      height: 100%;
      padding-right: 220px;
      overflow: auto;

      > .audit-table-wrapper {
        position: absolute;
        top: 0;
        right: 0;
        width: 200px;
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditRadarDevice.vue